import { loadStripe } from "@stripe/stripe-js";

const STRIPE_KEY = process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY;

export const stripePromise = STRIPE_KEY ? loadStripe(STRIPE_KEY) : null;
